import { NotificationsSettingPath } from '../../../constants/notifications';
import NotificationSettingEditStore from '../../../stores/notificationSettingEditStore';
import { defaultOrderStatusNotificationSetting } from '../constants';

export const orderStatusNotificationEditStore = new NotificationSettingEditStore(
  NotificationsSettingPath.ORDER,
  defaultOrderStatusNotificationSetting
);
